/* eslint-disable react/prop-types */
import React from "react";
import styles from "./Products.module.sass";

import api from "../../utils/api";
import currency from "../../utils/currency";

import ProductChooser from "../../components/ProductChooser/ProductChooser";
import SimulationChooser from "../../components/SimulationChooser/SimulationChooser";
import SimulationDetail from "../../components/SimulationDetail/SimulationDetail";
import Title from "../../components/Title/Title";
import AppContext from "../../contexts/appContext";

class Products extends React.Component {
  state = {
    products: [],
    selectedProduct: {},
    selectedSimulation: "",
    value: "",
    valid: false,
  };

  static contextType = AppContext;

  targetDiv = React.createRef();

  productClickHandler = (product) => {
    if (product.id !== this.state.selectedProduct.id) {
      this.setState({
        selectedProduct: product,
        selectedSimulation: "",
      });
      this.context.setContext({
        ...this.context,
        product: product,
      });
    }
  };

  simulationChooserClickHandler = (type) => {
    if (type !== this.state.selectedSimulation) {
      this.setState({
        selectedSimulation: type,
        value: "",
      });
    }
  };

  simulationValueHandler = (value) => {
    if (value !== this.state.value) {
      this.setState({
        value: value,
        valid: this.validate(),
      });
    }
  };

  getLimits() {
    let minVal,
      maxVal = 0;
    if (
      this.state.selectedProduct.id === "2" &&
      this.state.selectedSimulation === simulationType.CREDITO
    ) {
      minVal = 25000;
      maxVal = 150000;
    } else if (
      this.state.selectedProduct.id === "2" &&
      this.state.selectedSimulation === simulationType.PARCELA
    ) {
      minVal = 400;
      maxVal = 5000;
    } else if (
      this.state.selectedProduct.id === "1" &&
      this.state.selectedSimulation === simulationType.CREDITO
    ) {
      minVal = 70000;
      maxVal = 700000;
    } else if (
      this.state.selectedProduct.id === "1" &&
      this.state.selectedSimulation === simulationType.PARCELA
    ) {
      minVal = 600;
      maxVal = 10000;
    }

    return {
      minVal: minVal,
      maxVal: maxVal,
    };
  }

  getFormatedLimits() {
    return currency.objNumberToCurrency(this.getLimits());
  }

  startSimulationHandler = () => {
    const isParcela = this.state.selectedSimulation === simulationType.PARCELA;

    const simulationValue = currency.currencyToNumber(this.state.value);

    const requestBody = {
      produto: this.context.product,
      codigoComissionado: api.CODIGO_COMISSIONADO(),
      codigoEmpresa: api.CODIGO_EMPRESA,
      creditoFinal: isParcela
        ? "999999999"
        : (simulationValue * 1.1).toFixed(2),
      parcelaInicial: isParcela ? (simulationValue * 0.9).toFixed(2) : "0",
      parcelaFinal: isParcela
        ? (simulationValue * 1.1).toFixed(2)
        : "999999999",
      rendaTotal: api.RENDA_TOTAL,
      creditoInicial: isParcela ? "0" : (simulationValue * 0.9).toFixed(2),
    };

    api
      .post(api.endpoints.OFFERS, requestBody)
      .then((result) => {
        this.context.setContext({
          ...this.context,
          title: null,
          subtitle: null,
          redirectToPayment: false,
          product: this.state.selectedProduct,
          simulationType: this.state.selectedSimulation,
          simulationValue: this.state.value,
          priceValues: this.getLimits(),
          groups: result.data.bem.grupos,
        });

        this.props.history.push({
          pathname: "/ofertas",
        });
      })
      .catch(() => {
        this.context.setContext({
          ...this.context,
          title: null,
          subtitle: null,
          redirectToPayment: false,
          product: this.state.selectedProduct,
          simulationType: this.state.selectedSimulation,
          simulationValue: this.state.value,
          priceValues: this.getLimits(),
          groups: [],
        });

        this.props.history.push({
          pathname: "/ofertas",
        });
      });
  };

  validate() {
    const limits = this.getLimits();
    const value = currency.currencyToNumber(this.state.value);
    return value >= limits.minVal && value <= limits.maxVal;
  }

  componentDidMount() {
    const requestBody = {
      codigoComissionado: api.CODIGO_COMISSIONADO(),
    };

    api.post(api.endpoints.PRODUCTS, requestBody).then((result) => {
      this.setState({
        products: result.data.produtos,
      });
    });

    this.context.setContext({
      ...this.context,
      product: "",
    });
  }

  componentDidUpdate() {
    if (this.targetDiv.hasOwnProperty("scrollToDiv")) {
      this.targetDiv.scrollToDiv();
    }
  }

  render(props) {
    return this.state.products.length > 0 ? (
      <div className={styles.contentProducts}>
        <Title title="Qual bem você quer adquirir?" />

        <ProductChooser
          products={this.state.products}
          productClicked={this.productClickHandler}
          selectedProduct={this.state.selectedProduct}
        />

        {this.state.selectedProduct.id ? (
          <SimulationChooser
            ref={(el) => {
              this.targetDiv = el;
            }}
            simulationClicked={this.simulationChooserClickHandler}
            selectedSimulation={this.state.selectedSimulation}
            selectedProduct={this.state.selectedProduct}
          />
        ) : null}

        {this.state.selectedSimulation.length > 0 ? (
          <SimulationDetail
            ref={(el) => {
              this.targetDiv = el;
            }}
            simulate={this.startSimulationHandler}
            valueChanged={this.simulationValueHandler}
            limits={this.getFormatedLimits()}
            type={this.state.selectedSimulation}
            isValid={this.validate(this.getLimits(), this.state.value)}
            value={this.state.value}
            selectedProduct={this.state.selectedProduct}
          />
        ) : null}
      </div>
    ) : null;
  }
}

export const simulationType = {
  PARCELA: "parcela",
  CREDITO: "credito",
};

export default Products;
